// Digitalads.js
import React from 'react';

export default function Digitalads({ videolink, digitaladsimages }) {
  if (!videolink) {
    return null; 
  }

  const { heading, media, showinwebsite } = videolink;

  if (showinwebsite === 1) {
    return (
      <div className="digitalads">
        <div className="digitalads-txt">
          <p>
            {heading}
            <img src={digitaladsimages} alt="heading circle" />
          </p>
        </div>
        <div className="ads-youtube-video">
          {media.map(({ url }, index) => (
            <iframe key={index} title={`Video ${index}`}  src={url}></iframe>
          ))}
          <br />
        </div>
      </div>
    );
  } else {
    return <></>;
  }
}
